<template>
  <div>
    <!-- Feature Area Starts -->
    <section class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-4">
            <div class="single-feature mb-4 mb-lg-0">
              <h4>我的简历</h4>
              <p class="py-3">点击可以查看或者编辑简历内容</p>
              <a @click="toHome" class="secondary-btn"
                >GO<span class="flaticon-next"></span
              ></a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="single-feature mb-4 mb-lg-0">
              <h4>投递结果</h4>
              <p class="py-3">点击可以查看简历筛选和应聘进度</p>
              <a @click="toRecord" class="secondary-btn"
                >GO<span class="flaticon-next"></span
              ></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { existResume } from "@/api/resume";
export default {
  data: {
    resumed: false,
  },
  created() {},
  mounted() {
    this.getExistStatus();
  },
  methods: {
    getExistStatus() {
      existResume().then((res) => {
        console.log(res);
        this.resumed = res.data.data;
        console.log(this.resumed);
      });
    },
    toHome() {
      this.$router.push({
        path: "/home",
        query: {},
      });
    },
    toRecord() {
      this.$router.push({
        path: "/record",
        query: {},
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// About.vue?0052b586